import React from 'react';
import { Trash2, Play } from 'lucide-react';
import { ProjectImage } from '../../../types';
import Plyr from 'plyr-react';
import "plyr-react/plyr.css";

interface MediaGridProps {
  images: ProjectImage[];
  onRemove: (image: ProjectImage) => void;
}

export function MediaGrid({ images, onRemove }: MediaGridProps) {
  const getYouTubeThumbnail = (url: string) => {
    const videoId = url.match(/embed\/([^?]+)/)?.[1];
    return videoId ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg` : '';
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
      {images.map((image) => (
        <div key={image.id} className="relative group">
          {image.media_type === 'youtube' ? (
            <div className="relative w-full h-24">
              <img
                src={getYouTubeThumbnail(image.url)}
                alt="YouTube thumbnail"
                className="w-full h-full object-cover rounded-lg"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-black bg-opacity-50 rounded-full p-2">
                  <Play className="w-6 h-6 text-white" />
                </div>
              </div>
            </div>
          ) : image.media_type === 'video' ? (
            <div className="w-full h-24">
              <Plyr
                key={image.id}
                source={{
                  type: "video",
                  sources: [{ src: image.video_url || '', type: 'video/mp4' }]
                }}
                options={{
                  controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
                }}
              />
            </div>
          ) : (
            <img
              src={image.url}
              alt="Project"
              className="w-full h-24 object-cover rounded-lg"
            />
          )}
          <button
            onClick={() => onRemove(image)}
            className="absolute top-2 right-2 p-1 bg-red-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}